// extracted by mini-css-extract-plugin
export default {"ResizeHandleInner":"ResizeHandle_ResizeHandleInner__2aMtQ","ResizeHandleOuter":"ResizeHandle_ResizeHandleOuter__H-Z2b","Icon":"ResizeHandle_Icon__Ul2IE"};